// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BenchmarkEntityPicker_picker__9Frrq {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.BenchmarkEntityPicker_loading__xslBC {
  padding: 12px;
  text-align: center;
}

.BenchmarkEntityPicker_chips__bySrL {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.BenchmarkEntityPicker_chip__dLzpc {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px 4px 10px;
  background: #0f3460;
  color: #fff;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  max-width: 100%;
  min-width: 0;
}
.BenchmarkEntityPicker_chip__text__xGQqj {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  max-width: 220px;
}
.BenchmarkEntityPicker_chip__remove__0KfdW {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  padding: 0;
  border: none;
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s;
}
.BenchmarkEntityPicker_chip__remove__0KfdW:hover {
  background: rgba(255, 255, 255, 0.45);
}

.BenchmarkEntityPicker_hint__VQBYV {
  font-size: 11.5px;
  color: var(--grey-text, #94a3b8);
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/BenchmarkEntityPicker/BenchmarkEntityPicker.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AACF;AACE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AACJ;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,qCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;AAAJ;AAEI;EACE,qCAAA;AAAN;;AAKA;EACE,iBAAA;EACA,gCAAA;EACA,kBAAA;AAFF","sourcesContent":[".picker {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.loading {\n  padding: 12px;\n  text-align: center;\n}\n\n.chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px 4px 10px;\n  background: #0f3460;\n  color: #fff;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  max-width: 100%;\n  min-width: 0;\n\n  &__text {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n    max-width: 220px;\n  }\n\n  &__remove {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 14px;\n    height: 14px;\n    padding: 0;\n    border: none;\n    background: rgba(255, 255, 255, 0.25);\n    color: #fff;\n    border-radius: 50%;\n    font-size: 12px;\n    line-height: 1;\n    cursor: pointer;\n    transition: background 0.15s;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.45);\n    }\n  }\n}\n\n.hint {\n  font-size: 11.5px;\n  color: var(--grey-text, #94a3b8);\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"picker": `BenchmarkEntityPicker_picker__9Frrq`,
	"loading": `BenchmarkEntityPicker_loading__xslBC`,
	"chips": `BenchmarkEntityPicker_chips__bySrL`,
	"chip": `BenchmarkEntityPicker_chip__dLzpc`,
	"chip__text": `BenchmarkEntityPicker_chip__text__xGQqj`,
	"chip__remove": `BenchmarkEntityPicker_chip__remove__0KfdW`,
	"hint": `BenchmarkEntityPicker_hint__VQBYV`
};
export default ___CSS_LOADER_EXPORT___;
